import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { HEATMAP_WEEKDAY_LABELS } from './planUsageHeatmapData'

export function PlanUsageHeatmapWeekdayAxis() {
  return (
    <Stack spacing="2px" sx={{ flexShrink: 0, alignItems: 'center', pt: '2px' }}>
      {HEATMAP_WEEKDAY_LABELS.map((label, row) => (
        <Box key={row} sx={{ width: 16, height: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          {label ? (
            <Typography sx={{ fontSize: '13px', lineHeight: '16px', color: 'text.secondary' }}>{label}</Typography>
          ) : null}
        </Box>
      ))}
    </Stack>
  )
}
